import { IconAdd } from '@components/icons';

interface ImageGalleryAddTileProps {
  onClick: () => void;
  ariaLabel: string;
  disabled?: boolean;
}

export const ImageGalleryAddTile = ({ onClick, ariaLabel, disabled = false }: ImageGalleryAddTileProps) => (
  <button
    type='button'
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel}
    data-testid='image-gallery__add-tile'
    className='w-[60px] h-[60px] rounded-md border border-dashed border-primary bg-tertiary flex items-center justify-center text-primary transition-colors shrink-0 disabled:opacity-50 disabled:cursor-not-allowed'>
    <IconAdd className='w-5 h-5' />
  </button>
);
